//#region [IMPORT]

// === THIRD-PARTY ===
import React, {  } from 'react';
import { useTheme } from '@mui/material/styles';

// === STYLE / MATERIAL UI ===
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { Logo    } from './Logo/Logo'       ;
import { NavBar  } from './NavBar/NavBar'   ;
import { UserNav } from './UserNav/UserNav' ;
import { Spacer  } from 'components/Spacer' ;

import './menu.css';

//#endregion

//-----------------------------------------------------------------
export function Menu(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const _styles = {
    bar: {
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      padding    : '6px'   ,
      height     : '60px'  ,
      width      : '100%'  ,
      display    : 'flex'  ,
      alignItems : 'center',
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.bar} >
        <NavBar  />
        <Logo    />
        {props.children}
        <Spacer push_right />
        <UserNav />
      </Box>
    )
  }

  //#endregion

  return display();
}
